import Vue from "vue";
import Router from "vue-router";
import Main from "@/views/Main.vue";
import Home from "@/components/pages/Home.vue";
import Person from "@/components/pages/Person.vue";
import Search from "@/components/pages/Search.vue";
import BookRecomd from "@/components/pages/BookRecomd.vue";
import BorrowList from "./components/pages/BorrowList";
import CardBind from "./components/pages/CardBind";
import HistoryList from "./components/pages/HistoryList";
import HotBookList from "./components/pages/HotBookList";
import NewBookList from "./components/pages/NewBookList";
import SearchResult from "./components/pages/SearchResult";
import SetPwd from "./components/pages/SetPwd";
import EreaderCard from "./components/pages/EreaderCard";
import BookDetail from "./components/pages/BookDetail";
import AddHome from "./views/AddHome";
import Cookies from "js-cookie";
Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Main,
      children: [
        {
          path: "/",
          name: "Home",
          component: Home
        },
        {
          path: "/person",
          name: "Person",
          component: Person,
          meta: {
            title: "我的"
          }
        }
      ]
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
      meta: {
        title: "搜索"
      }
    },
    {
      path: "/bookRecomd",
      name: "BookRecomd",
      component: BookRecomd,
      meta: {
        title: "图书荐购"
      }
    },
    {
      path: "/borrowList",
      name: "BorrowList",
      component: BorrowList,
      meta: {
        title: "当前借阅"
      }
    },
    {
      path: "/historyList",
      name: "HistoryList",
      component: HistoryList,
      meta: {
        title: "历史借阅"
      }
    },
    {
      path: "/newBookList",
      name: "NewBookList",
      component: NewBookList,
      meta: {
        title: "新书速递"
      }
    },
    {
      path: "/hotBookList",
      name: "HotBookList",
      component: HotBookList,
      meta: {
        title: "热门图书"
      }
    },
    {
      path: "/searchResult",
      name: "SearchResult",
      component: SearchResult,
      meta: {
        title: "搜索"
      }
    },
    {
      path: "/cardBind",
      name: "CardBind",
      component: CardBind,
      meta: {
        title: ""
      }
    },
    {
      path: "/setPwd",
      name: "SetPwd",
      component: SetPwd,
      meta: {
        title: "修改密码"
      }
    },
    {
      path: "/eReaderCard",
      name: "EreaderCard",
      component: EreaderCard,
      meta: {
        title: "电子读者证"
      }
    },
    {
      path: "/bookDetail",
      name: "BookDetail",
      component: BookDetail
    },
    {
      path: "/addHome",
      name: "AddHome",
      component: AddHome,
      meta: {
        title: "添加到主屏幕"
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  let appointRouter = [
    "BorrowList",
    "HistoryList",
    "EreaderCard",
    "SetPwd",
    "BookRecomd",
    "Person"
  ];
  if (appointRouter.includes(to.name)) {
    if (!Cookies.get("openId")) {
      next({
        path: "/cardBind",
        query: {
          type: 1
        }
      });
    }
  }
  next();
});
router.afterEach(to => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});
export default router;
